import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "f-w-700" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["placeholder", "value"]
const _hoisted_7 = { class: "col-12" }

import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { usePromotionStore, typeList } from '@/store/management/promotionStore';
import type { Promotion } from '@/store/management/promotionStore';

import { useI18n } from 'vue-i18n'
import { promotionTypeLanguage } from '@/core/locales/promotions-language';


export default /*@__PURE__*/_defineComponent({
  __name: 'promotionType',
  setup(__props) {

const { t } = useI18n({
  messages: promotionTypeLanguage
})

const MultiBuy = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionType/MultiBuy.vue'))
const FixedValue = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionType/FixedValue.vue'))
const PercentageOff = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionType/PercentageOff.vue'))
const CheapestOneFree = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionType/CheapestOneFree.vue'))
const DiscountAfterN = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionType/DiscountAfterN.vue'))
const BuyXGetYFree = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionType/BuyXGetYFree.vue'))
const AmountOff = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionType/AmountOff.vue'))

const promotionStore = usePromotionStore()

const compState = reactive({
    type: '',
})

const activePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const tempActivePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const activePromotionId = computed(() => {
    return promotionStore.getActivePromotion.basic.id
})

const selectedTypeDescription = computed(() => {
    return typeList.find(type => type.id === compState.type)?.description
})

onMounted(() => {
    if (tempActivePromotion.value?.basic.id) {
        compState.type = tempActivePromotion.value.type.selectedType
    }
})

watch(activePromotionId, (newVal) => {
    if (newVal) {
        const promotion = activePromotion.value
        compState.type = promotion.type.selectedType
    }
}, { immediate: true });

watch(compState, (newVal) => {
    promotionStore.setActivePromotion({
        ...tempActivePromotion.value,
        type: {
            ...tempActivePromotion.value.type,
            selectedType: newVal.type
        }
    } as Promotion)
}, { deep: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, [
          _createElementVNode("h6", _hoisted_4, _toDisplayString(_unref(t)('SelectType')) + ":", 1)
        ]),
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.type) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeList), (trigger) => {
            return (_openBlock(), _createElementBlock("option", {
              value: trigger.id
            }, _toDisplayString(_unref(t)(trigger.name)), 9, _hoisted_5))
          }), 256))
        ], 512), [
          [_vModelSelect, compState.type]
        ]),
        _createElementVNode("textarea", {
          class: "form-control mt-3",
          placeholder: _unref(t)('Description'),
          style: {"resize":"none","height":"10rem"},
          readonly: "",
          value: selectedTypeDescription.value
        }, null, 8, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (compState.type === '1')
        ? (_openBlock(), _createBlock(_unref(MultiBuy), { key: 0 }))
        : (compState.type === '3')
          ? (_openBlock(), _createBlock(_unref(FixedValue), { key: 1 }))
          : (compState.type === '4')
            ? (_openBlock(), _createBlock(_unref(PercentageOff), { key: 2 }))
            : (compState.type === '5')
              ? (_openBlock(), _createBlock(_unref(CheapestOneFree), { key: 3 }))
              : (compState.type === '6')
                ? (_openBlock(), _createBlock(_unref(DiscountAfterN), { key: 4 }))
                : (compState.type === '7')
                  ? (_openBlock(), _createBlock(_unref(BuyXGetYFree), { key: 5 }))
                  : (compState.type === '8')
                    ? (_openBlock(), _createBlock(_unref(AmountOff), { key: 6 }))
                    : _createCommentVNode("", true)
    ])
  ]))
}
}

})